import styled from 'styled-components';
import { FlexContainer, Layout } from '@taxdown/piccolo-web';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled(FlexContainer)`
  max-width: 358px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const WrapContainer = styled(Layout.Wrap)`
  background-color: ${({ theme: { system } }) => system.background.fds_sys_color_background_cold};
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_M};
  border: 1px solid ${({ theme: { system } }) => system.accent.fds_sys_color_accent_cold};
`;
